<template>
    <modal name="selectDetailCarModelPopup" :width="850" :height="500" :clickToClose="false" @before-open="beforeOpen" @opened="opened">
        <div id="div_detailCarModel" class="popup on">
            <div class="pop_tit">
                차량세부모델 선택
            </div>
            <div id="div_detailCarModelPopupScroll" class="scroll_area pop_con_wrap" style="height:350px;">
                <div class="pop_search_bg" style="height:300px;">
                    <div class="board_list type02">
                        <div class="sub_left_wrap">
                            <div class="destxt pb10">
                                조회<span>{{this.gridTotal}}</span>건
                            </div>
                        </div>
                        <div class="sub_right_wrap">
                            <div class="destxt vam ml10">
                                차종코드가 동일한 경우 <span>부품호환</span> 이 가능합니다.
                            </div>
                        </div>
                        <!-- <table class="board_table"> -->
                        <grid :options="grid_options" v-once></grid>
                    </div>
                </div>
            </div>
            <div class="pop_footer_wrap">
                <div class="btn_area mt0">
                    <a href="javascript:void(0);" class="button blue" @click="getDetailCarModel"><span>선택</span></a>
                </div>
            </div>
            <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
        </div>
    </modal>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'

export default {
    name : 'selectDetailCarModelPopup',
    components : { Grid, GridModule, Vue },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            //pushToParent: '',
            gridTotal : '',
            transfer : [],
            carName : '',
            grid_options : {
                general : {
                  id  : 'detail-car-model-popup-grid',
                  search : '',
                  excel : false,    
                  type : {
                      isUpdate : false,
                      //isHideAdd : true : true,
                  },
                  params : {
                      manufactor: '',
                      carModelName: '',
                      carModelDetail: ''
                  }
                },
                grid_options : {
                    height: 240,
                    autoColumnIndex: true,
                    // rowindexColumnFromZero: false,
                    rowSelectOption:{
                        clickSelect: true,
                        singleSelect: true,
                        radioColumn: true,
                        allowSingleUnselect: false
                    },
                    paging: {
                        pagerTotal : false,
                        // hidePageList : false,
                        pagerSelect : false
                    },
                    
                    columnMapping : [
                        //{   key : 'brandId',          hidden: true },
                        //{   width : '30px',            selectorColumn : true   },
                        {   selectorColumn : true ,   title : '선택',          width : '46px', align : 'center' },
                        {   key : 'brandName',     title : '모델상세/배기량/원통기형식',      width : '370px', align : 'center'  },
                        {   key : 'brandEngName',     title : '차종코드',      width : '150px', align : 'center'  },
                        {   key : 'brandId',     title : '국내사양',      width : '100px', align : 'center'  },
                        {   key : 'sailDiscountRate',     title : '빈도',          width : '100px', align : 'center'  }
                    ]
                }
            }
        }
    },
    created() {
        //alert("created");
    },
    mounted () {
        //alert("mounted");
    },
    methods : {
        beforeOpen(e) {
            //변수 초기화
            this.grid_options.general.search = '';
            this.transfer = [];
            this.carName = '';
            this.gridTotal = 0;
            this.grid_options.general.params.manufactor = '';
            this.grid_options.general.params.carModelName = '';
            this.grid_options.general.params.carModelDetail = '';
        },
        opened(e) {
            //alert("Opened");
            
            //UI 좌측 상단 조회 카운트
            this.getGridListTotal();

            //팝업창 스크롤바 css 컨트롤(공통)
            $("#div_detailCarModelPopupScroll").mCustomScrollbar( {
                theme: "dark-thick",
                scrollInertia: 500
            });
            //팝업창 닫기 관련 css 컨트롤(공통)
            $("#div_detailCarModel").parent().css('overflow', 'visible');
        },
        close() {
            //this.$emit('parts-code-search-slide-complete', {});
            this.$modal.hide('selectDetailCarModelPopup');
        },
        searchDetailCarModel() {
            this.grid_options.general.PageInfo.current = 1;
            //alert("그리드검색세팅::" + JSON.stringify(this.grid_options.general.params));
            GridModule.searchData(this.grid_options);
            this.getGridListTotal();
        },
        //UI 그리드 왼쪽위 총합 표시 때문에 추가
        getGridListTotal() {
            this.gridTotal = 0;
                Vue.httpClient
                .get('/brand/list', {}) //{params : this.grid_options.general.params}
                .then((result) => {
                if ( result.data.result ) {
                    this.gridTotal = result.data.result.total;
                }
            })
        },
        getDetailCarModel(e) {
            var data = $('#' + this.grid_options.general.id).alopexGrid('dataGet', {_state: {selected:true}});
            for(var key in data) {
                this.transfer.push(data[key]);
            }

            //alert("transfer::" + JSON.stringify(this.transfer));
            //alert("transfer.brandName::" + this.transfer[0].brandName);
            this.carName = this.transfer[0].brandName;

            this.$emit('detail-car-model-complete', this.carName);
            this.$modal.hide('selectDetailCarModelPopup');
        }

    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/SelectDetailCarModelPopup.vue